import { call } from 'redux-saga/effects';
import Rollbar from 'mangools-commons/dist/configs/rollbar';
import { TechnicalErrorReportService } from 'mangools-commons/dist/services/TechnicalErrorReportService';

export function* logError(tag = 'UnknownSaga', payload) {
    yield call([Rollbar, Rollbar.error], new Error(`[${tag}]`), payload);
    // The wide net for the sources that do not report themselves; a failure a source already
    // reported is dropped inside reportSagaError.
    yield call([TechnicalErrorReportService, TechnicalErrorReportService.reportSagaError], tag, payload);
}

export function* logInfo(label, payload = {}) {
    yield call([Rollbar, Rollbar.info], label, payload);
}

export function handleUncaught(generator, errorGenerator) {
    return function* handlingUncaught(...args) {
        let value = null;
        try {
            value = yield call(generator, ...args);
        } catch (e) {
            console.error(`Unhandled error in '${generator.name}'`, e); // eslint-disable-line no-console

            // Call error generator if provided
            if (errorGenerator) {
                yield call(errorGenerator);
            }

            yield call(logError, generator.name, `UNHANDLED: ${e.toString()}`);
        }

        return value;
    };
}
